import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable ,  of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Job } from '../domain/job';
import { environment } from '../../environments/environment';
import { JOB_URI, JOBS_URI } from './shared-data.service';
import { ActiveJobs } from '../domain/activeJobs';
import { JobLog } from '../domain/JobLog';


@Injectable()
export class JobsService {

  constructor(
    private http: HttpClient) {
  }

  /** GET jobs from the server */
  getJobs(resource: string): Observable<Job[]> {
    const url = `${environment.apiConfig.uri}/systems/${resource}/${JOBS_URI}`;
    return this.http.get<Job[]>(url).pipe(
      catchError(this.handleError('getJobs', []))
    );
  }

  // get ALL Paginated Jobs
  getJobsPage(resource: string, page: string, size: string): Observable<Job[]> {
    const url = `${environment.apiConfig.uri}/systems/${resource}/${JOBS_URI}?` + "page=" + page + "&size=" + size;
    return this.http.get<Job[]>(url).pipe(
      catchError(this.handleError('getJobs', []))
    );
  }

  // get Paginated Jobs for specific location
  getLocationJobs(resource: string, location: string, page: string, size: string): Observable<Job[]> {
    const url = `${environment.apiConfig.uri}/systems/${resource}/${JOBS_URI}?` + "page=" + page + "&size=" + size + "&search=location¡" + location;
    return this.http.get<Job[]>(url).pipe(
      catchError(this.handleError('getJobs for location', []))
    );
  }

  // get Paginated Jobs with filters
  getFilteredJobs(resource: string, location: string, filters: string): Observable<Job[]> {
    let url = `${environment.apiConfig.uri}/systems/${resource}/${JOBS_URI}?`;
    url += filters;
    return this.http.get<Job[]>(url).pipe(
      catchError(this.handleError('get filtered Jobs', []))
    );
  }

  /** GET only one job and it details from the server */
  getJob(resource: string, jobId: string): Observable<Job> {
    return this.http.get<Job>(environment.apiConfig.uri + '/systems/' + resource + "/" + JOB_URI + "/" + jobId).pipe(
      catchError(this.handleError('getJob', null))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  // ENDPOINTS TO GET LISTS FOR FILTERS

  getLocations(machine: string) {
    return this.http.get<String[]>(environment.apiConfig.uri + '/systems/' + machine + "/" + "locations").pipe(
      catchError(this.handleError('getLocations', null))
    );
  }

  getFilterApps(machine: string, location: string) {
    return this.http.get<String[]>(environment.apiConfig.uri + '/systems/' + machine + "/locations/" + location + "/applications").pipe(
      catchError(this.handleError('get Applications for filter', null))
    );
  }

  getFilterJobNames(machine: string, location: string) {
    return this.http.get<String[]>(environment.apiConfig.uri + '/systems/' + machine + "/locations/" + location + "/jobNames").pipe(
      catchError(this.handleError('get Job Names for given location for filter', null))
    );
  }

  getFilterStatus(machine: string, location: string) {
    return this.http.get<String[]>(environment.apiConfig.uri + '/systems/' + machine + "/locations/" + location + "/status").pipe(
      catchError(this.handleError('get Status for filter', null))
    );
  }

  getAllApps(machine: string) {
    return this.http.get<String[]>(environment.apiConfig.uri + '/systems/' + machine + "/applications").pipe(
      catchError(this.handleError('get All Applications for filter', null))
    );
  }
  getJobLogs(jobDetails: string): Observable<string[]> {

    const url = `${environment.apiConfig.uri}/getJobquery/` + jobDetails;
    return this.http.get<string[]>(url).pipe(
      catchError(this.handleError('getJobs', []))
    );
  }

  getActiveJobLogs(jobname: string, jobuser: string, jobnumber: string,system:string): Observable<JobLog[]> {

    const url = environment.apiConfig.uri + '/systems/activejobs/' + jobname + "/" + jobuser + "/" + jobnumber+ "/" + system;

   
    return this.http.get<JobLog[]>(url).pipe(
      catchError(this.handleError('getActiveJobLogs', null))
    );

  }

  getAllJobNames(machine: string) {
    return this.http.get<String[]>(environment.apiConfig.uri + '/systems/' + machine + "/jobNames").pipe(
      catchError(this.handleError('get All Job Names for filter', null))
    );
  }

  getAllStatus(machine: string) {
    return this.http.get<String[]>(environment.apiConfig.uri + '/systems/' + machine + "/status").pipe(
      catchError(this.handleError('get All statuses for filter', null))
    );
  }

  getAllActiveStatusJobs(machine: string,userID: string) {
    return this.http.get<ActiveJobs[]>(environment.apiConfig.uri + '/systems/' + machine + "/" + userID + "/getActiveJobs").pipe(
      catchError(this.handleError('get All statuses for filter', null))
    );
  }


  getUserIdAuthForActiveJob(userID: string): Observable<string> {

    const url = environment.apiConfig.uri + '/systems/checkuser/callCobolCmd/' + userID;
    return this.http.get(url, {responseType: 'text'});

  }
}
